import { OmniaApiInterface } from "../shared/api/apiInterface";
import { ApplicationRateUnit, applicationUnits } from "../shared/applicationUnits";
import { roundArea } from "../shared/area";
import { camelCaseKeys, pascalCaseKeys } from "../shared/case";
import { changeLuminosity, colorToCss, createLinearGradient, getWhiteBlackForegroundFromBackgroundColor, hexToRgbArray, hexToRgbNumber, rgbNumFromArray, rgbNumToArray, rgbToHslArray, setOpacity } from "../shared/color/color";
import { MaterialColors } from "../shared/color/material";
import { createValuedColorsProvider, getColorForValue, getHorizontalBarBackgroundStyle, getHorizontalBarBackgroundStyle2, NumericRangeColorProvider, NumericValueColorProvider, ValuedColorsProvider } from "../shared/color/provider";
import { convertSeedRatesFromKg, convertSeedRatesToKg, convertThousandSeedsToKg, getCropManagementConfig, isCropHidden } from "../shared/crops";
import { CropYear, CropYearStartMonth } from "../shared/cropYear";
import { catchApiError, getConcurrencyErrorMessage, handleApiError, handleConcurrencyError, handleException, isApiConcurrencyError } from "../shared/error";
import { FieldAreaType, OmniaModuleId, OmniaObjectType, RegionId } from "../shared/generated/enums";
import { labels, param } from "../shared/generated/labels";
import { convertFeatureToWkt, convertGeometryToOpenLayers, convertGeometryToWkt } from "../shared/geom";
import { readGeometriesFromOmniaBinaryToIndex, getDefaultGeometryFormat } from "../shared/geom/binary";
import { msg } from "../shared/i18n/messages";
import { isTerraMapLayer } from "../shared/layers/utils";
import { isRegionInNvz } from "../shared/nutrition/nvz";
import { getParameters } from "../shared/parameters";
import { PrescriptionType, prescriptionTypes } from "../shared/prescriptions/types";
import { customProductKeyToGuid, guidToCustomProductKey, isCustomProductKey } from "../shared/products";
import { omniaAllPromises, omniaAllSeries, omniaDefer, omniaResolve } from "../shared/promises";
import { OmniaService } from "../shared/service";
import { hasAccessPermission, isAdmin, isAgronomist, isExternalRole, isHoldingOwner, isHoldingReadOnly } from "../shared/session/utils";
import { SoilUnit } from "../shared/soil";
import { str } from "../shared/strings";
import { EmptyGuidString, OmniaAppId } from "../shared/types";
import { RoleId } from "../shared/user";
import { defineComponent, defineDirective } from "../shared/utils/angular";
import { arrayMax, arrayMin, avg, compareArrays, createIndex, createLookup, createMap, createRange, except, flatten, getDistinctValues, groupBy, groupByEquality, isArrayEmpty, mergeLists, partition, range, selectMany, sum, takeWhile } from "../shared/utils/array";
import { checkDateIntersection, compareDates, convertDatesToJsonUtc, dateBetweenWithoutYear, dateCompareWithoutYear, formatDateDayMonth, formatDateToISOString, getDateRangeDescr, getDateString, getSelectedYearsLabel, setDates, toDate } from "../shared/utils/date";
import { checkEmailAddress, formatAsHtmlList, formatChemicalCompoundInTextAsHtml, formatChemicalCompoundInTextAsUnicode, formatChemicalCompoundNameAsHtml, formatChemicalCompoundNameAsUnicode } from "../shared/utils/format";
import { loadStylesheet } from "../shared/utils/loader";
import { memoize } from "../shared/utils/memoize";
import { getBaseName, getUniqueName, validateUniqueName } from "../shared/utils/naming";
import { nullOrUndefinedFirstCompareFn, numericTextSort } from "../shared/utils/numericTextSort";
import { cloneDeep, getObjectEntries, isObjectEmpty } from "../shared/utils/objects";
import { escape } from "../shared/utils/regexp";
import { addListener, checkEnumValue, equals, getIconClass, isArray, isDate, isDefined, isFunction, isImageContentType, isNumber, isObject, isString, isUndefined, isUndefinedOrNull, pad2, sortDates, stringOfEnum } from "../shared/utils/utils";
import { apps } from "./apps";
import { components } from "./components";
import { datalayers } from "./datalayers";
import { doclib } from "./doclib";
import { fields } from "./fields";
import { manure } from "./manure";
import { map } from "./map";
import { models } from "./models";
import { nutrition } from "./nutrition";
import { react } from "./react";
import { shell } from "./shell";
import { soil } from "./soil";
import { stocks } from "./stocks";
import { sync } from "./sync";
import * as enums from "../shared/generated/enums"
import { showPlanUpdateValidationDialog } from "@omnia/shared/plans/validation/validation";
import { showEditDialog as showHoldingPermissionsEditDialog } from "../shared_esm";

export const omnia = {

    isArray,
    isArrayEmpty,
    isDate,
    isNumber,
    isObject,
    isDefined,
    isUndefined,
    isUndefinedOrNull,
    isFunction,
    isString,
    nullOrUndefinedFirstCompareFn,
    numericTextSort,
    sortDates,
    omniaResolve,
    memoize,
    cloneDeep,
    equals,
    getObjectEntries,
    checkEnumValue,
    stringOfEnum,
    pascalCaseKeys,
    camelCaseKeys,
    isObjectEmpty,

    arrayMin,
    arrayMax,
    groupBy,
    groupByEquality,
    getDistinctValues,
    selectMany,
    createIndex,
    createMap,
    createLookup,
    partition,
    sum,
    except,
    avg,
    range,
    pad2,
    createRange,
    takeWhile,
    compareArrays,
    flatten,
    mergeLists,

    getSelectedYearsLabel,

    omniaAllSeries,
    omniaAllPromises,
    omniaDefer,

    addListener,

    loadStylesheet,

    getParameters,

    getIconClass,
    roundArea,

    convertDatesToJsonUtc,
    setDates,
    getDateRangeDescr,
    toDate,
    dateCompareWithoutYear,
    dateBetweenWithoutYear,
    compareDates,
    getDateString,
    checkDateIntersection,
    formatDateDayMonth,
    formatDateToISOString,

    isHoldingReadOnly,

    convertFeatureToWkt,
    convertGeometryToOpenLayers,
    convertGeometryToWkt,
    readGeometriesFromOmniaBinaryToIndex,
    getDefaultGeometryFormat,

    defineComponent,
    defineDirective,

    catchApiError,
    handleApiError,
    handleException,
    isApiConcurrencyError,
    handleConcurrencyError,
    getConcurrencyErrorMessage,

    isRegionInNvz,
    isAdmin,
    isAgronomist,
    isHoldingOwner,
    isExternalRole,
    hasAccessPermission,

    isCropHidden,

    isTerraMapLayer,

    isImageContentType,

    isCustomProductKey,
    guidToCustomProductKey,
    customProductKeyToGuid,

    CropYear,

    OmniaAppId,
    FieldAreaType,
    OmniaModuleId,
    OmniaObjectType,
    RoleId,
    RegionId,

    EmptyGuidString,

    OmniaService,
    OmniaApiInterface,

    str,

    msg,

    components,

    CropYearStartMonth,

    PrescriptionType,
    prescriptionTypes,

    param,
    labels,
    enums,

    shell,
    fields,
    react,
    models,
    map,
    datalayers,
    soil,
    stocks,
    nutrition,
    sync,
    doclib,
    manure,
    apps,

    exports: {
        // Temporary placeholder to avoid errors when compiling
        // subprojects with "isolatedModules": true
        dummy: true as const
    },

    SoilUnit,

    ApplicationRateUnit,
    ApplicationRateUnits: applicationUnits,

    crops: {
        getCropManagementConfig,
        convertSeedRatesToKg,
        convertSeedRatesFromKg,
        convertThousandSeedsToKg
    },

    color: {
        colorToCss,
        createLinearGradient,
        rgbToHslArray,
        getWhiteBlackForegroundFromBackgroundColor,
        getHorizontalBarBackgroundStyle,
        getHorizontalBarBackgroundStyle2,
        createValuedColorsProvider,
        changeLuminosity,
        setOpacity,
        rgbNumToArray,
        rgbNumFromArray,
        hexToRgbNumber,
        hexToRgbArray,
        getColorForValue,
        NumericValueColorProvider,
        NumericRangeColorProvider,
        ValuedColorsProvider,
        MaterialColors
    },

    format: {
        formatAsHtmlList,
        formatChemicalCompoundNameAsHtml,
        formatChemicalCompoundInTextAsHtml,
        formatChemicalCompoundNameAsUnicode,
        formatChemicalCompoundInTextAsUnicode,
        checkEmailAddress
    },

    utils: {
        regexp: {
            escape
        },
        naming: {
            getUniqueName,
            validateUniqueName,
            getBaseName
        }
    },

    showPlanUpdateValidationDialog,

    permissions: {
        showHoldingPermissionsEditDialog
    }

}
